"use client";

import { c as _c } from "react/compiler-runtime";
import { useInView } from "react-intersection-observer";
const STATS_STYLE = `
    .stat-rule::before {
        content: '';
        position: absolute;
        top: 0; left: 0; right: 0;
        height: 1px;
        background: linear-gradient(90deg, transparent, rgba(249,243,238,0.10), transparent);
    }
`;
const stats = [{
  number: 16,
  suffix: "",
  label: "Countries",
  sub: "Documented worldwide"
}, {
  number: 2400,
  suffix: "+",
  label: "Archive",
  sub: "Records preserved"
}, {
  number: 850,
  suffix: "+",
  label: "Research",
  sub: "Reports published"
}, {
  number: 120,
  suffix: "+",
  label: "Scholars",
  sub: "& Researchers"
}];
const formatStat = n => n.toLocaleString("en-IN");
const Stats = () => {
  const $ = _c(13);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      triggerOnce: true,
      threshold: 0.25
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    ref,
    inView
  } = useInView(t0);
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <style>{STATS_STYLE}</style>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="absolute top-0 left-0 right-0 h-px" style={{
      background: "linear-gradient(90deg, transparent, rgba(139,58,42,0.4), transparent)"
    }} />;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="absolute inset-0 opacity-[0.03]" style={{
      backgroundImage: "radial-gradient(circle at 80% 50%, #C9A84C 0%, transparent 60%)"
    }} />;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <div className="flex items-center gap-3 pt-8 sm:pt-12 pb-6 sm:pb-10 border-b border-white/[0.06]"><div className="w-6 h-px bg-[#DF6D2A]" /><span className="font-body text-[11px] sm:text-[14px] tracking-[0.2em] sm:tracking-[0.25em] uppercase text-white/60">Impact in Numbers</span></div>;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== inView) {
    t5 = stats.map(item => <div key={item.label} className="stat-rule relative py-6 sm:py-10 px-3 sm:px-6 lg:first:pl-0 lg:last:pr-0 flex flex-col gap-1.5 sm:gap-2 group border-b border-white/[0.06] lg:border-b-0 odd:border-r border-r-white/[0.06] lg:odd:border-r-0"><span className="font-display text-[40px] sm:text-[54px] md:text-[72px] lg:text-[80px] font-light text-[#F4EFE6] leading-none tracking-[-0.02em] tabular-nums">{inView ? formatStat(item.number) : "0"}{item.suffix && <span className="text-[#DF6D2A]">{item.suffix}</span>}</span><div className="w-8 h-px bg-[#DF6D2A] mt-1 mb-2 transition-all duration-500 group-hover:w-16" /><span className="font-body text-[12px] sm:text-[15px] tracking-[0.08em] sm:tracking-[0.1em] uppercase text-[#F4EFE6]/80 font-light">{item.label}</span><span className="font-body text-[12px] sm:text-[15px] font-light text-[#4C596B] tracking-wide">{item.sub}</span></div>);
    $[5] = inView;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== t5) {
    t6 = <div className="grid grid-cols-2 lg:grid-cols-4 lg:divide-x divide-white/[0.06]">{t5}</div>;
    $[7] = t5;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <div className="h-px" style={{
      background: "linear-gradient(90deg, rgba(139,58,42,0.3), transparent)"
    }} />;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== ref || $[11] !== t6) {
    t8 = <>{t1}<section className="font-body bg-[#0F1C2E] relative overflow-hidden">{t2}{t3}<div ref={ref} className="max-w-[1280px] mx-auto px-6 md:px-8">{t4}{t6}{t7}</div></section></>;
    $[10] = ref;
    $[11] = t6;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  return t8;
};
export default Stats;